import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {requestPassword} from '../redux/AuthCRUD'

const initialValues = {
  email: '',
  phone: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Định dạng email không hợp lệ')
    .min(3, 'Định dạng email không hợp lệ')
    .max(50, 'Định dạng email không hợp lệ')
    .required('Email là bắt buộc'),
  phone: Yup.string()
    .min(10, 'Định dạng số điện thoại không hợp lệ')
    .max(11, 'Định dạng số điện thoại không hợp lệ')
    .required('Điện thoại là bắt buộc'),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [errMesssage, setErrMsg] = useState<string | null>(null)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        requestPassword(values.email, values.phone)
          .then(({data: {result}}) => {
            setHasErrors(false)
            setErrMsg(null)
            setLoading(false)
          })
          .catch((e: any) => {
            setErrMsg(e?.response?.data?.message || e?.message || 'Đã có lỗi xảy ra! Vui lòng thử lại.')
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('Thông tin không hợp lệ, vui lòng thử lại!')
          })
      }, 1000)
    },
  })

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Cấp lại mật khẩu ?</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>Vui lòng nhập email và số điện thoại.</div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && errMesssage !== null && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              {errMesssage}
            </div>
          </div>
        )}

        {hasErrors === false && (
          <div className='mb-10 bg-light-info p-8 rounded'>
            <div className='text-info'>Mật khẩu mới đã được gửi tới email của bạn. Vui lòng kiểm tra!</div>
          </div>
        )}
        {/* end::Title */}

        {/* begin::Form group */}

        <div className='fv-row mb-10'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
          <input
            type='email'
            placeholder=''
            autoComplete='off'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.email}</span>
              </div>
            </div>
          )}
        </div>
        <div className='fv-row mb-10'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>Điện thoại</label>
          <input
            type='string'
            placeholder=''
            autoComplete='off'
            {...formik.getFieldProps('phone')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.phone && formik.errors.phone},
              {
                'is-valid': formik.touched.phone && !formik.errors.phone,
              }
            )}
          />
          {formik.touched.phone && formik.errors.phone && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.phone}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button
            type='submit'
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4'
            disabled={formik.isSubmitting || !formik.isValid || loading}
          >
            {loading ? (
              <span className='indicator-progress d-block'>
                Đang xử lý...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              <span className='indicator-label'>Gửi</span>
            )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Quay lại Đăng nhập
            </button>
          </Link>
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
